import React from 'react';
import {AppBar, Tabs, Tab, Box} from '@material-ui/core';
import ConsultForm from './../component/ConsultForm';
import {i18n2} from 'features/i18n/i18n';
import KPIForm from './../component/KPIForm';
import SectorForm from './../component/SectorForm';
import ReasonForm from './../component/ReasonForm';
import MonthlyForm from './../component/MonthlyForm';

function TabPanel(props) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ConsultPage = (props) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange}>
          <Tab label={i18n2._('Consulta por usuario')} {...a11yProps(0)} />
          <Tab label={i18n2._('Consulta por mes')} {...a11yProps(1)} />
          <Tab label={i18n2._('Consulta por sector')} {...a11yProps(2)} />
          <Tab label={i18n2._('KPI')} {...a11yProps(3)} />
          <Tab label={i18n2._('Razón tardanza')} {...a11yProps(4)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <ConsultForm />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <MonthlyForm />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <SectorForm />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <KPIForm />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <ReasonForm />
      </TabPanel>
    </>
  );
};

export default ConsultPage;
